import React, { forwardRef } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Input, InputAdornment } from '@mui/material';

/**
 * Shared list-search field. Search execution remains owned by the page so the
 * component can be reused with local state, Redux state, and URL-backed state.
 */
const OlcSearchInput = forwardRef(
  ({ value = '', searchApplied = false, onClear, className = '', ...inputProps }, ref) => {
    const hasValue = String(value ?? '').trim().length > 0;
    const classes = ['searchInput', searchApplied ? 'searchApplied' : '', className]
      .filter(Boolean)
      .join(' ');

    return (
      <Input
        {...inputProps}
        ref={ref}
        className={classes}
        value={value}
        endAdornment={
          hasValue && onClear ? (
            <InputAdornment position="end" className="searchInputAdornment">
              <IconButton
                aria-label="Clear search"
                className="cpClearInputBtn"
                edge="end"
                onMouseDown={(event) => event.preventDefault()}
                onClick={onClear}
                size="small"
                sx={{ padding: '4px' }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null
        }
      />
    );
  }
);

OlcSearchInput.displayName = 'OlcSearchInput';

export default OlcSearchInput;
